<template>
  <v-breadcrumbs icons divider="chevron_right">
    <v-breadcrumbs-item
      v-for="item in breadcrumbs" :key="item.text"
      :disabled="item.disabled"
      router
      :href="getHref(item)"
    >
      {{ item.text }}
    </v-breadcrumbs-item>
  </v-breadcrumbs>
</template>

<script>
  export default {
    props: {
      breadcrumbs: {
        type: Array,
        required: true
      }
    },

    methods: {
      getHref(item) {
        if(!item.disabled && item.href) {
          return `#${item.href}`;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// IsrsBreadcrumb.vue?5eb0171a